/* eslint-disable max-len */

import { getCookieByName, getEnvironmentVariables } from "./general";
import type { Language } from "../types";

export function persistLanguage (item: Language){
  const { corporateDomain } = getEnvironmentVariables();

  document.cookie = `languageStored=${JSON.stringify(item)};secure; domain=${corporateDomain}; path=/; max-age=31536000`;
  document.cookie = `activeLangCode=${item.id}; path=/; max-age=31536000; domain=${corporateDomain}`;
}

export function getLanguage() {
  const itemStored = getCookieByName("languageStored");

  if (itemStored) {
    return JSON.parse(itemStored) as Language;
  } else {
    return undefined;
  }
}
